import React, { useState } from "react";
import "./styles.scss";
import { log_error } from "./../../../api";
import _ from "lodash";
import { createMedium } from "../../../api/media";
import { ProgressBar } from "react-bootstrap";
import { uploadMedia } from "../../../api/aws_s3";
import { object_url, getCurrentUser } from "../../../api/helper";
import ImagePicker from "../../shared/ImagePicker";
import { isWithinSoundtrackSizeLimit } from "../viewsHelper";
import { createLink } from "../../../api/media";

export default (props) => {
  const [preview_image_id, setPreviewImageId] = useState(null);
  const [type, setType] = useState("");
  const [file, setFile] = useState(null);
  const [alert, setAlert] = useState("");
  const [progress, setProgress] = useState(null);
  const [fileName, setFileName] = useState("");
  const [is_track_type, setIsTrackType] = useState("");
  const [link, setLink] = useState("");

  const onChangeFile = (e) => {
    setType("");
    setFileName(e.target.files[0].name);
    setFile(e.target.files[0]);
    if (e.target.files[0].type == "audio/mpeg") {
      setIsTrackType("newsfeed_track");
    }

    if (e.target.files && e.target.files[0]) {
      const type = e.target.files[0].type;
      let target = type.substr(0, type.indexOf("/"));
      switch (target) {
        case "video":
          setType("Video");
          break;
        case "audio":
          setType("SoundTrack");
          break;
        case "image":
          setType("Image");
          break;
        default:
          setType("Image");
      }
    }
  };
  const getAcceptAttribute = (_t) => {
    switch (_t) {
      case "Video":
        return "video/*";
      case "SoundTrack":
        return "audio/*";
      case "Image":
        return "image/*";
      default:
        return "";
    }
  };
  const onUpload = async () => {
    try {
      if (!file) throw Error("Select a file");
      if (!isWithinSoundtrackSizeLimit(file))
        throw Error("Oops! Your file size is too large. Try uploading a smaller version that is 300MB or less.");
      props.isUploading && props.isUploading(true);
      let s3_object_key = object_url();
      await uploadMedia(file, file.type, getCurrentUser().id, s3_object_key, (e) => {
        setProgress((e.loaded * 100) / e.total);
      });
      let {
        data: { medium },
      } = await createMedium({
        media: {
          s3_object_key,
          type,
          preview_image_id,
          is_track_type,
        },
      });
      setAlert({ text: "Uploaded!", class: "success" });
      props.onUploaded(medium);
    } catch (error) {
      console.log(log_error(error));
      setAlert({ text: log_error(error), class: "danger" });
    } finally {
      setProgress(null);
      props.isUploading && props.isUploading(false);
    }
  };

  const onChangeLink = (e) => {
    setType("");
    props.embadedURL && props.embadedURL(e.target.value);
  };

  return (
    <div id="media_uploader" className={props.className}>
      <div className="d-flex flex-column justify-content-between">
        {props.mediaUploaderType == "link" ? (
          <div>
            <div className="form-group">
              <input
                type="text"
                name="photo"
                id="upload-by-input"
                className="link-uploader form-control"
                placeholder="Insert link"
                onChange={onChangeLink}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="form-group">
              {fileName ? (
                <label className="label" htmlFor="upload-by-input">
                  {fileName}
                </label>
              ) : (
                <label className="label" htmlFor="upload-by-input">
                  Select {props.mediaUploaderType}...
                </label>
              )}
              <input type="file" name="photo" id="upload-by-input" className="image-uploader" onChange={onChangeFile} />
            </div>
            <div className="form-group">
              <button className="btn btn-primary btn-sm" onClick={onUpload}>
                Upload
              </button>
            </div>
            {!_.isNull(progress) && (
              <div className="form-group">
                <label>Progress</label>
                <ProgressBar now={progress} />
              </div>
            )}
          </div>
        )}
      </div>
      {alert && (
        <div className={`alert alert-${alert.class}`}>{Array.isArray(alert.text) ? alert.text.map((err) => <li>{err.message}</li>) : alert.text}</div>
      )}
    </div>
  );
};
